import React from "react";

/** Reusable tag/pill. Renders nothing when text is falsy. */
export function Tag({ children, tone = "neutral", testId }) {
  const tones = {
    neutral: "bg-slate-100 text-slate-700",
    accent: "bg-indigo-50 text-indigo-700",
    success: "bg-emerald-50 text-emerald-700",
    warning: "bg-amber-50 text-amber-800",
    danger: "bg-rose-50 text-rose-700",
  };
  if (!children && children !== 0) return null;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${tones[tone]}`}>
      {children}
    </span>
  );
}

/** Reusable list-of-tags. */
export function TagList({ items = [], max, tone = "neutral" }) {
  const arr = Array.isArray(items) ? items : String(items || "").split(",").map((s) => s.trim()).filter(Boolean);
  const visible = max ? arr.slice(0, max) : arr;
  const rest = max ? Math.max(0, arr.length - max) : 0;
  if (visible.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {visible.map((v) => (<Tag key={v} tone={tone}>{v}</Tag>))}
      {rest > 0 && <Tag tone="neutral">+{rest}</Tag>}
    </div>
  );
}
